import { QueryClient } from '@tanstack/react-query'
import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { arbitrum } from 'wagmi/chains'

const config = getDefaultConfig({
	appName: 'RNDM Jeeve',
	projectId: 'YOUR_PROJECT_ID',
	chains: [arbitrum],
	ssr: true,
})

const queryClient = new QueryClient()

export { config, queryClient }
